import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { AddAuthorizedDriverComponent } from "./add-authorized-driver/add-authorized-driver.component";
import { EditAuthorizedDriverComponent } from "./edit-authorized-driver/edit-authorized-driver.component";
import { ImportAuthorizedDriverComponent } from "./import-authorized-driver/import-authorized-driver.component";
import { DataService_AuthorizedDrivers } from "./shared/data.service";
import { PreferenceGetRequest } from "./shared/PreferenceGetRequest";

@Component({
	selector: "app-driver-verify-authorized-drivers",
	templateUrl: "./driver-verify-authorized-drivers.component.html",
	styleUrls: ["./driver-verify-authorized-drivers.component.css"],
})
export class DriverVerifyAuthorizedDriversComponent implements OnInit {
	constructor(
		private userService: UserService,
		private AuthorizedDriversService: DataService_AuthorizedDrivers,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadDriverVerifyAuth();
		this.loadImportPreference();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	Processing: any = false;

	ToggleText: any = "Deactivate Driver";

	ImportLoading: any = true;
	DriversImported: any = true;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedDriverVerifyAuth: any;
	lstDriverVerifyAuth: any = [];

	//Filter lists
	lstActiveDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LicenseNbr", header: "License Number" },
		{ field: "DriverName", header: "Name" },
		// { field: 'ActiveDesc', header: 'Active' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadImportPreference() {
		this.ImportLoading = true;

		let parms: PreferenceGetRequest = {
			Category: "DriverVerify",
			KeyName: "AuthorizedUsersImported",
			SchoolID: -1,
		};

		var result = this.AuthorizedDriversService.PreferenceGet(parms);
		result.subscribe(
			(response) => {
				var data = response[0];

				this.DriversImported = Number(data) == 1 ? true : false;

				this.ImportLoading = false;

				this.loadDriverVerifyAuth();
			},
			(error) => {
				this.ImportLoading = false;
			}
		);
	}

	loadDriverVerifyAuth() {
		this.loading = true;

		var result = this.AuthorizedDriversService.AuthorizedDriverSelectList();
		result.subscribe(
			(response) => {
				this.lstDriverVerifyAuth = response;

				//Load Data Filter Lists
				this.lstActiveDesc = Array.from(new Set(this.lstDriverVerifyAuth.map((item: any) => item.ActiveDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadDriverVerifyAuth();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		if (this.DriversImported == true) {
			this.errorMessage = "Drivers are managed by import and can't be added or edited manually";
			return;
		}

		var ref = this.dialogService.open(AddAuthorizedDriverComponent, {
			header: "Add Driver",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadDriverVerifyAuth();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		if (this.DriversImported == true) {
			this.errorMessage = "Drivers are managed by import and can't be added or edited manually";
			return;
		}

		if (this.SelectedDriverVerifyAuth == undefined) {
			this.errorMessage = "Select a driver to edit";
			return;
		}

		var ref = this.dialogService.open(EditAuthorizedDriverComponent, {
			header: "Edit Driver",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				DriverVerifyAuthID: this.SelectedDriverVerifyAuth.DriverVerifyAuthID,
				LicenseNbr: this.SelectedDriverVerifyAuth.LicenseNbr,
				DriverName: this.SelectedDriverVerifyAuth.DriverName,
				Active: this.SelectedDriverVerifyAuth.Active,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadDriverVerifyAuth();
			}
		});
	}

	onToggle() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedDriverVerifyAuth == undefined) {
			this.errorMessage = "Select a driver to toggle";
			return;
		}

		//Call SP
		this.Processing = true;

		var changeTo = this.SelectedDriverVerifyAuth.Active == 1 ? 0 : 1;

		var result = this.AuthorizedDriversService.AuthorizedDriverToggle(this.SelectedDriverVerifyAuth.DriverVerifyAuthID, changeTo);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadDriverVerifyAuth();
				} else {
					var MSG = "";

					if (changeTo == 1) {
						MSG = "Could not activate the driver";
					} else {
						MSG = "Could not deactivate the driver";
					}

					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ImportAuthorizedDriverComponent, {
			header: "Import Drivers",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadDriverVerifyAuth();
			}
		});
	}

	onDelete() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedDriverVerifyAuth == undefined) {
			this.errorMessage = "Select a driver to delete";
			return;
		}

		//Call SP
		this.Processing = true;

		var result = this.AuthorizedDriversService.AuthorizedDriverDelete(this.SelectedDriverVerifyAuth.DriverVerifyAuthID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadDriverVerifyAuth();
				} else {
					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the driver",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onDeleteInactive() {
		this.errorMessage = "";

		//Call SP
		this.Processing = true;

		var result = this.AuthorizedDriversService.AuthorizedDriverDeleteInactive();
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadDriverVerifyAuth();
				} else {
					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete inactive drivers",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClear(DriverVerifyAuthID) {
		this.errorMessage = "";

		//Call SP
		this.Processing = true;

		var result = this.AuthorizedDriversService.AuthorizedDriverClearOverride(DriverVerifyAuthID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadDriverVerifyAuth();
				} else {
					//
					// Error message
					//
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not clear the driver's override attempts",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedDriverVerifyAuth = val.data;

		this.ToggleText = "Deactivate Driver";
		if (this.SelectedDriverVerifyAuth.Active == 0) {
			this.ToggleText = "Activate Driver";
		}
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedDriverVerifyAuth = null;

		this.ToggleText = "Deactivate Driver";
	}
	onRowDblClick(DriverVerifyAuth) {
		this.errorMessage = "";

		this.SelectedDriverVerifyAuth = DriverVerifyAuth;

		this.ToggleText = "Deactivate Driver";
		if (this.SelectedDriverVerifyAuth.Active == 0) {
			this.ToggleText = "Activate Driver";
		}

		this.onEdit();
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.Processing == true || this.ImportLoading == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
